import { render, staticRenderFns } from "./ManageInvoices.vue?vue&type=template&id=2e830be5&"
import script from "./ManageInvoices.vue?vue&type=script&lang=js&"
export * from "./ManageInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports